import { create } from "zustand";

const useAuth = create((set) => ({
  user: null,
  loadingInit: true,
  loadingAuth: false,
  setAuth: (data) => set((state) => ({ ...state, ...data })),
  setLoadingAuth: (loadingAuth) => set({ loadingAuth }),
  setLoadingInit: (loadingInit) => set({ loadingInit }),
  resetAuth: () => set({
    user: null,
    loadingAuth: false,
  }),  
}));

export default useAuth;
